import { Tooltip } from '@mui/material';
import { selectParams, selectPageRefWrappingStyle } from 'common/selectors';
import { createPageRef } from 'features/case/redux/createPageRef';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const ExhibitNumber = ({
  currentFileMetaData,
  currentPageNumber,
  fileId,
  startPageForGlobalPaging,
}: {
  currentFileMetaData: any;
  currentPageNumber: number;
  fileId: string;
  startPageForGlobalPaging: string;
}) => {
  const dispatch = useDispatch();
  const { case: aCase, file } = useSelector(selectParams);
  const pageRefWrappingStyle = useSelector(selectPageRefWrappingStyle);
  const [openTooltip, setOpenTooltip] = useState(false);

  const exhibitNumber = currentFileMetaData?.exhibitNumber;
  const displayText = `${exhibitNumber} / ${currentPageNumber}`;

  const copyToClipboard = () => {
    const isFirstPage = Number(currentPageNumber) === 1;
    let text = isFirstPage ? `${exhibitNumber}` : displayText;
    if (!pageRefWrappingStyle || pageRefWrappingStyle === 'braces') {
      text = `{${text}}`;
    } else if (pageRefWrappingStyle === 'brackets') {
      text = `[${text}]`;
    }

    const safeMeta = currentFileMetaData || {};
    const startPage = startPageForGlobalPaging || safeMeta.startPage;

    const url =
      `${window.location.origin}/case/${aCase}/files/${fileId || file}?goToPage=${currentPageNumber}` +
      `${safeMeta.tab ? `&tab=${safeMeta.tab}` : ''}` +
      `${startPage ? `&startPage=${startPage}` : ''}` +
      `${safeMeta.pageCount ? `&pageCount=${safeMeta.pageCount}` : ''}` +
      `${safeMeta.globalPagePrefix ? `&globalPagePrefix=${safeMeta.globalPagePrefix}` : ''}` +
      `${exhibitNumber ? `&exhibitNumber=${exhibitNumber}` : ''}`;

    const htmlToCopy = `<a href="${url}" style="text-decoration: none; color: inherit;">${text}</a>`;

    navigator.clipboard
      .write([
        new ClipboardItem({
          'text/html': new Blob([htmlToCopy], { type: 'text/html' }),
          'text/plain': new Blob([text], { type: 'text/plain' }),
        }),
      ])
      .then(() => {
        handleTooltipOpen();
        dispatch(createPageRef({ globalPage: text }));
      })
      .catch((err) => {
        console.error('Failed to copy: ', err);
      });
  };

  const handleTooltipClose = () => setOpenTooltip(false);
  const handleTooltipOpen = () => setOpenTooltip(true);

  useEffect(() => {
    if (openTooltip) {
      setTimeout(() => {
        setOpenTooltip(false);
      }, 1500);
    }
  }, [openTooltip]);
  // Don't render if exhibitNumber is not available
  if (!exhibitNumber) {
    return null;
  }

  return (
    <Tooltip
      placement="top"
      onClose={handleTooltipClose}
      open={openTooltip}
      disableFocusListener
      disableHoverListener
      disableTouchListener
      title={`${displayText} - Copied to clipboard`}
      arrow
      PopperProps={{ style: { zIndex: 100007 } }}
    >
      <div
        className="pageNumber pageNumber--exhibit"
        onDoubleClick={(e: React.MouseEvent) => {
          e.stopPropagation();
          e.preventDefault();
          copyToClipboard();
        }}
      >
        <div style={{ marginLeft: '0.3rem' }}>
          <span>{displayText}</span>
        </div>
      </div>
    </Tooltip>
  );
};

export default ExhibitNumber;
